import { addOrUpdateBaseInfo, getStateSelectList } from '../api'

export default {
  data() {
    return {
      customerInfoSchema: [
        {
          label: 'Customer #',
          type: 'Despace',
          key: 'code',
        },
        {
          label: 'Customer Name',
          type: 'input',
          key: 'name',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'GEO',
          type: 'select',
          placeholder: 'All',
          key: 'geo',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          change: this.handleGeoSelectChange,
        },
        {
          label: 'Region',
          type: 'select',
          placeholder: 'All',
          key: 'region',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          change: this.handleRegionChange,
        },
        {
          label: 'Sales Country',
          type: 'select',
          key: 'salesCountry',
          placeholder: 'All',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Business Type',
          type: 'select',
          placeholder: 'All',
          key: 'business',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Payment Term(Day)',
          type: 'input',
          key: 'paymentTermReq',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
            {
              min: 0,
              max: 200,
              message: 'No more than 200 characters.',
              trigger: 'blur',
            },
          ],
        },
        {
          label: 'In Business Since',
          type: 'date',
          key: 'registerDate',
        },
        {
          label: 'Year With Lenovo Since',
          type: 'date',
          key: 'signDate',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Address',
          type: 'input',
          key: 'address',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'City',
          type: 'input',
          key: 'city',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'State',
          type: 'select',
          key: 'state',
          selectList: [],
          placeholder: 'All',
        },
        {
          label: 'Registration Country',
          type: 'select',
          placeholder: 'All',
          key: 'country',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          change: this.handleRegistraCountry,
        },
        {
          label: 'ZIP Code',
          type: 'input',
          key: 'zipCode',
        },
        {
          label: 'CCA',
          type: 'select',
          placeholder: 'All',
          key: 'cca',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Currency',
          type: 'select',
          placeholder: 'All',
          key: 'currency',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Duns #',
          type: 'input',
          key: 'dunsNo',
        },
        {
          label: 'National Registration # or VAT #',
          type: 'input',
          key: 'registeredNo',
        },
        {
          label: 'Sub-Region',
          type: 'input',
          key: 'subRegion',
        },

        {
          label: 'Source',
          type: 'select',
          placeholder: 'All',
          key: 'source',
          disabled: true,
          selectList: [
            { id: 1, name: 'Lenovo' },
            { id: 2, name: 'CSS' },
          ],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },

        // {
        //   label: 'Phone',
        //   type: 'input',
        //   key: 'mobile',
        // },
        {
          label: 'Risk Category in SAP',
          type: 'select',
          key: 'sapRiskType',
          placeholder: 'All',
          selectList: [
            {
              id: '001',
              name: '001',
            },
            {
              id: '002',
              name: '002',
            },
            {
              id: '003',
              name: '003',
            },
            {
              id: '004',
              name: '004',
            },
            {
              id: '005',
              name: '005',
            },
            {
              id: '006',
              name: '006',
            },
            {
              id: '999',
              name: '999',
            },
          ],
        },
        {
          label: 'Sold to #',
          type: 'input',
          key: 'soldPartyNo',
        },

        // {
        //   label: 'LINK ID',
        //   type: 'input',
        //   key: 'linkId',
        // },
        {
          label: 'BU',
          type: 'select',
          key: 'bu',
          placeholder: 'All',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Hierarchy Level',
          type: 'select',
          key: 'hierarchyLevel',
          placeholder: 'All',
          disabled: true,
          selectList: [
            {
              id: 1,
              name: 'Parent',
            },
            {
              id: 2,
              name: 'Subsidiary',
            },
          ],
        },
        {
          label: 'Channel',
          type: 'select',
          key: 'channel',
          placeholder: '',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          selectList: [
            {
              name: 'ECC',
              id: 'ECC',
            },
            {
              name: 'S4',
              id: 'S4',
            },
            {
              name: 'NAS4',
              id: 'NAS4',
            },
            {
              name: 'ESOT',
              id: 'ESOT',
            },
          ],
        },
        {
          label: 'Stock Code',
          type: 'input',
          key: 'stockCode',
        },
        // {
        //   label: 'Public Sentiment',
        //   type: 'select',
        //   key: 'publicSentiment',
        //   placeholder: '',
        //   selectList: [
        //     {
        //       name: 'YES',
        //       id: 1,
        //     },
        //     {
        //       name: 'NO',
        //       id: 2,
        //     },
        //   ],
        // },
      ],
      isShowCustomerInfoForm: false,
    }
  },
  methods: {
    async handleCustomerInfoSaveBtn() {
      try {
        const customerInfo = this.$refs.customerInfo
        const valid = await customerInfo.validateFields()
        if (valid) {
          const params = customerInfo.getFormData()
          params.code = params.code.replace(/[ ]/g, '')
          const data = await addOrUpdateBaseInfo(params)
          if (data.name === 2) {
            this.$message.warning('The customer name already exists')
          }
          this.isShowCustomerInfoForm = false
          await this._getCustomerInfo()
        }
      } catch (err) {
        console.log(err)
        return Promise.reject(err)
      }
    },
    async handleGeoSelectChange(value, formData) {
      try {
        const res = await this._getSelectList({
          typeMark: 'Region',
          pid: value,
        })

        for (let i = 0; i < this.customerInfoSchema.length; i++) {
          const item = this.customerInfoSchema[i]
          if (item.label === 'Region') {
            item['selectList'] = res
          }
        }
        this.customerInfo.base = { ...formData }
        this.customerInfo.base.region = ''
      } catch (err) {
        console.log(err)
      }
    },
    async handleRegionChange(value, formData) {
      console.log(value)
      try {
        // 当region == OEM时，不联动，显示所有国家 region的value为1396671261928956221
        const regionOEM = [
          '1396671261928956221',
          '1485507981976072193',
          '1485507838971277313',
          '1485504000834990081',
          '1485508292971130882',
          '1485508065744711682',
        ]
        if (regionOEM.includes(value)) {
          const res1 = await this._getSelectList({
            typeMark: 'Country',
          })
          for (let i = 0; i < this.customerInfoSchema.length; i++) {
            const item = this.customerInfoSchema[i]
            if (item.label === 'Sales Country') {
              item['selectList'] = res1
            }
          }
        } else {
          // sales country
          if (!value) {
            for (let i = 0; i < this.customerInfoSchema.length; i++) {
              const item = this.customerInfoSchema[i]
              if (item.label === 'Sales Country') {
                item['selectList'] = []
              }
            }
            this.customerInfo.base = { ...formData }
            this.customerInfo.base.salesCountry = ''
            return
          }
          const res2 = await this._getSelectList({
            typeMark: 'Country',
            pid: value,
          })
          for (let i = 0; i < this.customerInfoSchema.length; i++) {
            const item = this.customerInfoSchema[i]
            if (item.label === 'Sales Country') {
              item['selectList'] = res2
            }
          }
        }
        this.customerInfo.base = { ...formData }

        // 添加一个条件判断，如果为日本，自动选择
        if (value === '1396671261948956118') {
          this.customerInfo.base.salesCountry = '1434758103312457'
        } else {
          this.customerInfo.base.salesCountry = ''
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleRegistraCountry(value) {
      if (value === '14347581033124127' || value === '1613372802212085762') {
        value = '1'
      }
      const res = await getStateSelectList(value)
      for (let i = 0; i < this.customerInfoSchema.length; i++) {
        const item = this.customerInfoSchema[i]
        if (res.length) {
          if (item.label === 'State') {
            item['placeholder'] = 'All'
          }
        } else {
          if (item.label === 'State') {
            item['placeholder'] = 'NA'
          }
        }
        if (item.label === 'State') {
          item['selectList'] = res.map(item => ({
            id: item.state,
            name: item.state,
            value: item.state,
          }))
        }
      }
    },
  },
}
